import "core-js/modules/es6.function.name";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  maxScrollbar: function maxScrollbar(state) {
    return state.app.maxScrollbar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  avatar: function avatar(state) {
    return state.user.avatar;
  },
  apps: function apps(state) {
    return state.user.apps;
  },
  appId: function appId(state) {
    return state.user.appId;
  },
  name: function name(state) {
    return state.user.name;
  },
  introduction: function introduction(state) {
    return state.user.introduction;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  permission_operation: function permission_operation(state) {
    return state.permission.operationButtons;
  },
  permission_tree_menus: function permission_tree_menus(state) {
    return state.permission.treeMenus;
  },
  errorLogs: function errorLogs(state) {
    return state.errorLog.logs;
  },
  accessedMenu: function accessedMenu(state) {
    return state.user.accessedMenu;
  }
};
export default getters;